import {connect} from "react-redux";
import {Col} from "reactstrap";
import React from "react";
import {useHistory, useLocation, useParams} from "react-router-dom";

const PaginaDireitaOAI = React.lazy( () => import("../../../components/Home/PaginaDireitaOAI"))
const SeletorRepositorios = React.lazy( () => import("../../../components/Home/SeletorRepositorios"))
const FiltroEsquerdo = React.lazy( () => import("../../../components/Home/FiltroEsquerdo"))

/**
 *
 * @param guiasPesquisaRx
 * @param consultaRx
 * @param itensConsulta
 * @returns {JSX.Element}
 * @constructor
 */
const ConteudoPesquisaOAI = ({ guiasPesquisaRx, consultaRx,  itensConsulta }) => {

    const location = useLocation()
    const history = useHistory();
    const  { guia = null } = useParams();
    const { base } = consultaRx;

    const guiaSelecionada = guia || (guiasPesquisaRx && guiasPesquisaRx?.length && guiasPesquisaRx.find(guia => guia.ordem === 0)?.codigo);

    return (<>
        <Col
            md="3"
            xs="12"
            className="b-w1 b-tema50 pt-3 pl-2 pr-2"
        >
            <SeletorRepositorios
                guiaSelecionada={guiaSelecionada}
                location={location}
                history={history}
            />
            <FiltroEsquerdo
                guiaPesquisa={base}
            />
        </Col>
        <Col
            xs="12"
            md="9"
            className="pr-0 border-left b-w1 b-tema50"
        >
            <PaginaDireitaOAI
                itensConsulta={itensConsulta}
            />
        </Col>
    </>)
}

const mapStateToProps = state => ({
    guiasPesquisaRx: state.pageConfig.guiasPesquisa,
    consultaRx : state.pesquisa.consulta
});


export default connect(mapStateToProps)(ConteudoPesquisaOAI);
